<div class="info-card {{ infoCardColor }}">
    @if (icon) {
        <div class="icon">
            <i class="{{ icon }}"></i>
        </div>
    }
    <div class="content">
        @if (title) {
            <div>
                <h6 class="text-center pt-2">
                    <b>{{ title }}</b>
                </h6>
            </div>
        }
        <div [ngClass]="{ body: !isHollow, 'hollow-body': isHollow }">
            <ng-content></ng-content>
        </div>
    </div>
</div>
